import { useLoaderData } from '@remix-run/react';

import { templateType } from '~/routes/$/constants/template-types';
import { StandardLayout } from '~/routes/$/layouts/StandardLayout';
import { type SectionMap } from '~/types/template';

import { DynamicPageTemplate } from './components/DynamicPageTemplate/DynamicPageTemplate';
import { LandingPageTemplate } from './components/LandingPageTemplate/LandingPageTemplate';
import type { loader } from './loader.server';

export { meta } from './meta';
export { handle } from './handle';

export default function PageTemplateImpl() {
  const rootLoaderData = useLoaderData<typeof loader>();
  if (!rootLoaderData) {
    throw new Error('Root loader data is missing');
  }

  const { genericConfig, hasBannerAds, sections } = rootLoaderData;
  const sectionMap = sections as SectionMap;

  if (rootLoaderData.templateType === templateType.LANDING_PAGE) {
    const { backgroundImage, ctaSubText, ctaText, ctaUrl, h1Heading, introText } = rootLoaderData;
    return (
      <LandingPageTemplate
        backgroundImage={backgroundImage}
        ctaSubText={ctaSubText}
        ctaText={ctaText}
        ctaUrl={ctaUrl}
        genericConfig={genericConfig}
        h1Heading={h1Heading}
        introText={introText}
        sections={sectionMap}
      />
    );
  }

  return (
    <StandardLayout {...rootLoaderData} {...genericConfig}>
      <DynamicPageTemplate genericConfig={genericConfig} hasBannerAds={hasBannerAds} sections={sectionMap} />
    </StandardLayout>
  );
}
